import { render, staticRenderFns } from "./PopupDetailWithHoldings.vue?vue&type=template&id=fd6680b4"
import script from "./PopupDetailWithHoldings.vue?vue&type=script&lang=js"
export * from "./PopupDetailWithHoldings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports